/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
};
export const filterOrganizationGlobalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.ORGANIZATION_FILTER + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ORGANIZATION_FILTER + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ORGANIZATION_FILTER + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
